/**
 * @param shouldShowFullSizeConversion
 * @param isFullSize
 * @param isMini
 * @returns {*}
 */
export default function shouldAddFullSizeBadgeDiscountPercentageProductUtil ({
  shouldShowFullSizeConversion,
  isFullSize,
  isMini
}) {
  return false
  // return (
  //   !isMini && (
  //     shouldShowFullSizeConversion || (
  //       isFullSize &&
  //       (
  //         isBlackFridayOrCyberMondayUrlLocationUtil() ||
  //         isSampleOrSubCollectionLocationUtil()
  //       )
  //     )
  //   )
  // )
}
